import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import PARKING_WIMQ from '../../assets/wimq.png'

const getSize = (variant, width) => {
  if ( width ) return width;
  switch (variant) {
    case 'h4':
      return 30;
    case 'subtitle2':
      return 22;
    case 'h1':
    default:
      return 80;
  }
};

const useStyles = makeStyles((theme) => ({
  container: {
    width: (props) => getSize(props.variant, props.width),
    height: (props) => getSize(props.variant, props.width),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: (props) => props.color,
    boxShadow: 'none',
    color: theme.palette.base.white,
    cursor: 'pointer',
    borderRadius: 5,
    border: 'solid 1px rgba(0, 0, 0, 0.2)',
  },
  parkingLetter: {
    textShadow: 'none',
  }
}));

const ParkingSymbol = ({
  className,
  variant,
  color,
  handleClick,
  connectionType,
  widthSymbol,
  width
}) => {
  const classes = useStyles({ variant, color, width });
  return (
    <div className={classnames(classes.container, className)} onClick={handleClick}>
      {connectionType==='WIMQ' &&
        <img src={PARKING_WIMQ} width={widthSymbol}/>
      }
      {connectionType!=='WIMQ' &&
        <Typography variant={variant} ><div className={classes.parkingLetter} >P</div> </Typography>
      }
    </div>
  );
};

ParkingSymbol.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  handleClick: PropTypes.func,
};

ParkingSymbol.defaultProps = {
  className: '',
  variant: 'h1',
  color: '#16BBCF',
  handleClick: undefined,
};

export default ParkingSymbol;
